<template>
    <div>

       <div class="reset-password-container" :class="{isTpg:isTpg}">
        <div class="alert alert-danger login-alert" v-if="error">
            <p>{{ error }}</p>
        </div>

        <div v-if="hasResetSuccessfully" class="successfullyReset">
          You have successfully reset your password, click <u><a href="/">here</a></u> to login.
        </div>

        <div v-else>
            <div class="reset-header">Reset your password</div>
            <div class="password-requirements">
                Your password must be a minimum of 8 characters, contain an UPPERCASE letter, a lowercase letter, a number, and a special character.
            </div>

            <form method="post" enctype="multipart/form-data" @submit.prevent="submitForm" class="form-check">

          <div class="form-group">
              <label for="password" class="col-md-4 control-label">Password</label>

              <div class="col-md-8">
                  <input id="password" type="password" class="form-control" name="password" autocomplete="new-password" required v-model="pass" autofocus>
              </div>
          </div>

          <div class="form-group">
              <label for="password-confirm" class="col-md-4 control-label">Confirm Password</label>
              <div class="col-md-8">
                  <input id="password-confirm" type="password" class="form-control" name="password-confirmation" autocomplete="new-password" required v-model="passConfirm" >
              </div>
          </div>

          <div class="form-group">
            <div class="col-md-12" style="margin-top:20px;">
              <button class="sign-in-button" @click="submitForm()" type="button" :disabled="loading">
                  Reset Password
              </button>
            </div>

        </div>

       </form>
      </div>
    </div>

    </div>
</template>

<script>
const Querystring = require('querystring');

export default {
  props: [
    'is-tpg',
  ],
  data() {
    return {
      email: '',
      passConfirm: '',
      pass: '',
      error: '',
      loading: false,
      hasResetSuccessfully: false
    };
  },
  mounted() {
    this.error = '';
    this.email = this.$route.query.email || '';
  },
  methods: {

    submitForm() {
      if (this.loading) {
        return;
      }

      this.loading = true;
      this.error = '';

      this.resetPass();

      // if (this.passwordIsStrong()) {
      //   //document.reset_form.submit();
      //   this.resetPass();
      // } else {
      //   this.error = "Your passwords must match and be at least 8 characters long, contain at least one uppercase letter, at least one lowercase letter, at least one number, and at least one special character";
      // }
    },
    passwordsMatch() {
      if (this.pass == this.passConfirm) {
        return true;
      }
    },
    // passwordIsStrong: function() {
    //   var gvRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\+\:\;\<\>\,\/\_\-\.\,])(?=.{8,})");
    //   if (gvRegex.test(this.pass)) {
    //     return true;
    //   }

    //   return;
    // },
    serverError(err) {
      const body = err && err.response && err.response.data;
      const fields = body && body.data && body.data.fields;

      if (fields) {
        return Object.keys(fields)
          .reduce((all, key) => all.concat(fields[key]), [])
          .join(' ');
      }

      if (body && body.message) {
        return body.message;
      }

      return 'We could not reset your password. Your reset link may have expired. Please request a new one.';
    },
    resetPass() {
      const token = this.$route.params.token;
      const credentials = {
        email: this.email,
        password: this.pass,
        password_confirmation: this.passConfirm,
        token: token,
      };
      const self = this;
      this.$http.post('/password/reset', Querystring.stringify(credentials)).then(() => {
        self.loading = false;
        self.error = '';
        self.hasResetSuccessfully = true;
      })
        .catch((err) => {
          self.loading = false;
          self.error = self.serverError(err);
        });
    },
  },
};

</script>

<style scoped>

.login-alert {
  position:relative;
  width:100%;
  top:-65px;
}
.login-form-text-field  {
  padding-left: 10px;
}
input[type="email"],input[type="password"] {
  border:1px solid #666;
    width:100%;
    height:35px;
}
::-webkit-input-placeholder {
  color: #ccc;
}
.successfullyReset {
  margin:0 auto;
  width:400px;
  padding:40px;
  text-align:center;
  background:#ccc;
  border-radius:5px;
  margin-top:20px;
  color: black;
}
    .reset-header {
        width:200px;
        margin:0 auto;

        text-align:center;
        font-size:20px;
        margin-bottom:30px;
    }
    .password-requirements {
        width:100%;
        margin:0 auto;
        text-align:center;
        font-size:14px;
        margin-bottom:40px;
        opacity:.7;
    }

</style>
